import axios from "axios";
import { useNavigate, Link } from "react-router-dom";
import { Tooltip } from "antd";
import { useEffect, useState } from "react";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { FaQuestionCircle } from "react-icons/fa";
import {
	traerDatos,
	HeadersAuth,
	CheckExpiracion,
	traerDatosObjeto,
} from "../funciones_utiles";
import {
	validarSoloTexto,
	validarEmail,
	validarTextoNumerico,
	validarTelefono,
} from "../validaciones";

const MySwal = withReactContent(Swal);

// const MemoizedChartEmisionesMulti = React.memo(ChartEmisionesMulti);
//DESCARGAR MOMENT JS
export const FormularioPreCambio = ({ sesion, cerrarModal }) => {
	const navigate = useNavigate();

	const [tempDatosPreCambio, setTempDatosPreCambio] = useState({});
	const URI =
		process.env.REACT_APP_DOMINIO + process.env.REACT_APP_PUERTO + "/user";
	useEffect(() => {
		if (sesion.pre_cambio) {
			(async () => {
				const datosConsumo = await traerDatosObjeto(URI);
				// console.log(await traerDatosObjeto(URI))
				setTempDatosPreCambio(datosConsumo);
			})();
		} else {
			setTempDatosPreCambio({
				nombre: sesion.nombre || "",
				apellido: sesion.apellido || "",
				direccion: sesion.direccion || "",
				telefono: sesion.telefono || "",
				email: sesion.email || "",
				obra_social: sesion.obra_social || "",
			});
		}
	}, [URI]);

	var [tooltipVisible, setTooltipVisible] = useState({
		nombre: false,
		apellido: false,
		direccion: false,
		telefono: false,
		email: false,
		obra_social: false,
	});
	const [errores, setErrores] = useState({
		nombre: "",
		apellido: "",
		direccion: "",
		telefono: "",
		email: "",
		obra_social: "",
	});
	const campos = [
		{ name: "nombre", validator: validarSoloTexto },
		{ name: "apellido", validator: validarSoloTexto },
		{ name: "direccion", validator: validarTextoNumerico },
		{ name: "telefono", validator: validarTelefono },
		{ name: "email", validator: validarEmail },
		{ name: "obra_social", validator: validarTextoNumerico },
	];

	let URI_NUEVO_CALCULO;

	const handleChange = async (e) => {
		const { id, value } = e.target;
		// console.log("ES : " + value);

		setTempDatosPreCambio({
			...tempDatosPreCambio,
			[id]: value,
		});

		let erroresTemp = { ...errores };
		const validarCampo = async (campo, valor) => {
			const resultadoValidacion = await campo(valor);
			return {
				mensaje: resultadoValidacion.mensaje,
				valido: resultadoValidacion.valido,
			};
		};
		const campoActual = campos.find((campo) => campo.name === id);

		if (campoActual) {
			const mira = await validarCampo(campoActual.validator, value);
			erroresTemp[id] = mira.mensaje;
			setTooltipVisible((prevState) => ({
				...prevState,
				[id]: !mira.valido,
			}));
			setTimeout(() => {
				setTooltipVisible((prevState) => ({
					...prevState,
					[id]: false,
				}));
			}, 3000);
		}

		setErrores(erroresTemp);
	};
	let classEmail = "";

	const guardar = async (e) => {
		e.preventDefault();
		let hayErrores = false;
		const erroresTemp = {};
		for (const campo of campos) {
			const valorCampo = String(tempDatosPreCambio[campo.name]);
			const resultadoValidacion = await campo.validator(
				valorCampo,
				tooltipVisible
			);

			if (resultadoValidacion.valido === false) {
				hayErrores = true;
				erroresTemp[campo.name] = resultadoValidacion.mensaje;
				setTooltipVisible((prevState) => ({
					...prevState,
					[campo.name]: !resultadoValidacion.valido,
				}));
				setTimeout(() => {
					setTooltipVisible((prevState) => ({
						...prevState,
						[campo.name]: false,
					}));
				}, 3000);
			}
		}
		if (hayErrores) {
			setErrores(erroresTemp);
			return;
		} else {
			let cambio;

			if (sesion.pre_cambio) {
				cambio = await axios.put(URI, tempDatosPreCambio, HeadersAuth);
			} else {
				cambio = await axios.post(URI, tempDatosPreCambio, HeadersAuth);
			}
			// console.log(cambio.data.e);
			if (cambio.data.errors) {
				const errores = cambio.data.errors;
				// console.log(errores)
				const msgError = errores.map((error) => {
					return "<pre>" + error.msg + "</pre>";
				});
				MySwal.fire({
					html: `${msgError}`,
					imageHeight: 65,
					confirmButtonText: "Ok",
				});
			} else {
				if (cambio.data.code === 409) {
					CheckExpiracion();
				} else {
					if (cambio.data.code === 200) {
						MySwal.fire({
							html: "Guardado con éxito",
							imageHeight: 65,
							icon: "success",
							confirmButtonText: "Ok",
							customClass: {
								confirmButton: "btn-confirmar",
							},
						}).then(() => {
							window.location.reload();
						});
						cerrarModal(false);
						// navigate("/panel");
					}
				}
			}
		}
	};

	return (
		<>
			<form onSubmit={guardar}>
				<label className="label-datos" htmlFor="nombre">
					Nombre
				</label>
				<Tooltip
					overlayClassName="custom-tooltip"
					title={!!errores.nombre && <span>{errores.nombre}</span>}
					open={tooltipVisible.nombre}
					color="#0a5694">
					<input
						className="input-login"
						type="text"
						placeholder={"Nombre"}
						id="nombre"
						value={tempDatosPreCambio.nombre || ""}
						onChange={handleChange}
					/>
				</Tooltip>

				<label className="label-datos" htmlFor="apellido">
					Apellido
				</label>
				<Tooltip
					overlayClassName="custom-tooltip"
					title={!!errores.apellido && <span>{errores.apellido}</span>}
					open={tooltipVisible.apellido}
					color="#0a5694">
					<input
						className="input-login"
						type="text"
						placeholder={"Apellido"}
						id="apellido"
						value={tempDatosPreCambio.apellido || ""}
						onChange={handleChange}
					/>
				</Tooltip>

				<label className="label-datos" htmlFor="direccion">
					Dirección
				</label>
				<Tooltip
					overlayClassName="custom-tooltip"
					title={!!errores.direccion && <span>{errores.direccion}</span>}
					open={tooltipVisible.direccion}
					color="#0a5694">
					<input
						className="input-login"
						type="text"
						placeholder={"Dirección"}
						id="direccion"
						value={tempDatosPreCambio.direccion || ""}
						onChange={handleChange}
					/>
				</Tooltip>

				<label className="label-datos" htmlFor="telefono">
					Teléfono
				</label>
				<Tooltip
					overlayClassName="custom-tooltip"
					title={!!errores.telefono && <span>{errores.telefono}</span>}
					open={tooltipVisible.telefono}
					color="#0a5694">
					<input
						className="input-login"
						type="text"
						placeholder={"Teléfono"}
						id="telefono"
						value={tempDatosPreCambio.telefono || ""}
						onChange={handleChange}
					/>
				</Tooltip>

				<label className="label-datos" htmlFor="email">
					Correo electrónico
				</label>
				<Tooltip
					overlayClassName="custom-tooltip"
					title={!!errores.email && <span>{errores.email}</span>}
					open={tooltipVisible.email}
					color="#0a5694">
					<input
						className={
							sesion.pre_cambio
							  ? (tempDatosPreCambio.email === "" || tempDatosPreCambio.email === null)
								? "input-login aviso-email"
								: "input-login"
							  : (sesion.email === "" || sesion.email === null)
								? "input-login aviso-email"
								: "input-login"
						  }
						type="text"
						placeholder={"Correo electrónico"}
						id="email"
						value={tempDatosPreCambio.email || ""}
						// value={ sesion.pre_cambio ? tempDatosPreCambio.email : sesion.email}
						onChange={handleChange}
					/>
				</Tooltip>
						 
				<label className="label-datos" htmlFor="obra_social">
					Obra Social
				</label>
				<Tooltip
					title={!!errores.obra_social && <span>{errores.obra_social}</span>}
					open={tooltipVisible.obra_social}
					color="#0a5694">
					<input
						className="input-login"
						type="text"
						placeholder={"Obra social"}
						id="obra_social"
						value={tempDatosPreCambio.obra_social || ""}
						// value={ sesion.pre_cambio ? tempDatosPreCambio.obra_social : sesion.obra_social}
						onChange={handleChange}
					/>
				</Tooltip>
				{sesion.pre_cambio
							  ? (tempDatosPreCambio.email === "" || tempDatosPreCambio.email === null)
								? <p className="texto-aviso">Por favor para mayor seguridad, ingrese un correo electronico.</p>
								: ""
							  : (sesion.email === "" || sesion.email === null)
								? <p className="texto-aviso">Por favor para mayor seguridad, ingrese un correo electronico.</p>
								: ""}
				
				<button className="btn-login" style={{ marginTop: "1rem" }}>
					Guardar
				</button>
			</form>
		</>
	);
};
